module.exports = "<ngx-loading [show]=\"loading\" [config]=\"commonService.config\">\n</ngx-loading>\n<div class=\"text-center\">\n  {{message}}\n</div>"